type BrandMarkProps = {
  inverse?: boolean
  size?: 'small' | 'medium' | 'large'
}

export function BrandMark({ inverse = false, size = 'medium' }: BrandMarkProps) {
  return (
    <img
      className={`brand-mark brand-mark-${size}${inverse ? ' on-dark' : ''}`}
      src="/brand/fifthwave-mark.svg"
      alt=""
      aria-hidden="true"
    />
  )
}

export function FifthwaveDigitalLogo({ compact = false }: { compact?: boolean }) {
  return (
    <img
      className={`fifthwave-primary-logo${compact ? ' compact' : ''}`}
      src="/brand/fifthwave-digital-primary.svg"
      alt="Fifthwave Digital"
    />
  )
}

export function ProductLockup({ inverse = false, compact = false }: { inverse?: boolean; compact?: boolean }) {
  if (compact) {
    return (
      <span className={`product-lockup compact${inverse ? ' inverse' : ''}`} aria-label="Swell AI — a Fifthwave Digital product">
        <BrandMark inverse={inverse} size="small" />
        <span className="product-lockup-copy">
          <strong>SWELL AI</strong>
          <span>A Fifthwave Digital product</span>
        </span>
      </span>
    )
  }

  return (
    <img
      className={`product-primary-logo${inverse ? ' inverse-surface' : ''}`}
      src="/brand/swell-lockup.svg"
      alt="Swell AI — a Fifthwave Digital product. AI governance, portfolio and value."
    />
  )
}
